// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__nV6jH","approved":"Status_approved__2L8y2","rejected":"Status_rejected__sBM9O","expired":"Status_expired__17Ikw","label":"Status_label__1LDrm"};